"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVaApplianceType = isVaApplianceType;
exports.isMatroxApplianceType = isMatroxApplianceType;
const types_1 = require("./api/v1/types");
function isVaApplianceType(applianceType) {
    return [
        types_1.ApplianceType.nimbraVA220,
        types_1.ApplianceType.nimbraVA225,
        types_1.ApplianceType.nimbra410,
        types_1.ApplianceType.nimbra412,
        types_1.ApplianceType.nimbra414,
        types_1.ApplianceType.nimbra414b,
        types_1.ApplianceType.nimbraVAdocker,
    ].includes(applianceType);
}
function isMatroxApplianceType(applianceType) {
    return [
        types_1.ApplianceType.matroxMonarchEdgeE4_8Bit,
        types_1.ApplianceType.matroxMonarchEdgeE4_10Bit,
        types_1.ApplianceType.matroxMonarchEdgeD4,
        types_1.ApplianceType.matroxMonarchEdgeS1,
    ].includes(applianceType);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwbGlhbmNlVHlwZVV0aWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvYXBwbGlhbmNlVHlwZVV0aWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFXQSw4Q0FVQztBQUVELHNEQWFDO0FBcENELDBDQUE4QztBQVc5QyxTQUFnQixpQkFBaUIsQ0FBQyxhQUE0QjtJQUMxRCxPQUFPO1FBQ0gscUJBQWEsQ0FBQyxXQUFXO1FBQ3pCLHFCQUFhLENBQUMsV0FBVztRQUN6QixxQkFBYSxDQUFDLFNBQVM7UUFDdkIscUJBQWEsQ0FBQyxTQUFTO1FBQ3ZCLHFCQUFhLENBQUMsU0FBUztRQUN2QixxQkFBYSxDQUFDLFVBQVU7UUFDeEIscUJBQWEsQ0FBQyxjQUFjO0tBQy9CLENBQUMsUUFBUSxDQUFDLGFBQWEsQ0FBQyxDQUFBO0FBQzdCLENBQUM7QUFFRCxTQUFnQixxQkFBcUIsQ0FDakMsYUFBNEI7SUFNNUIsT0FBTztRQUNILHFCQUFhLENBQUMsd0JBQXdCO1FBQ3RDLHFCQUFhLENBQUMseUJBQXlCO1FBQ3ZDLHFCQUFhLENBQUMsbUJBQW1CO1FBQ2pDLHFCQUFhLENBQUMsbUJBQW1CO0tBQ3BDLENBQUMsUUFBUSxDQUFDLGFBQWEsQ0FBQyxDQUFBO0FBQzdCLENBQUMifQ==